import type * as Types from '../../types';

import type { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
import document from './userUnsubscribedRestaurantsByUnsubscribeTokenQuery.gql';
import type * as ApolloReactCommon from '~/lazy_apollo/client';
import * as ApolloReactHooks from '~/lazy_apollo/client';
const defaultOptions = {} as const;
export type UserUnsubscribedRestaurantsByUnsubscribeTokenQuery_userByUnsubscribeToken_User_followers_Follower = {
  __typename: 'Follower',
  id: number
};

export type UserUnsubscribedRestaurantsByUnsubscribeTokenQuery_userByUnsubscribeToken_User_emailUnsubscribedRestaurants_Restaurant = {
  __typename: 'Restaurant',
  id: number,
  name: string
};

export type UserUnsubscribedRestaurantsByUnsubscribeTokenQuery_userByUnsubscribeToken_User = {
  __typename: 'User',
  id: number,
  followers: Array<UserUnsubscribedRestaurantsByUnsubscribeTokenQuery_userByUnsubscribeToken_User_followers_Follower>,
  emailUnsubscribedRestaurants: Array<UserUnsubscribedRestaurantsByUnsubscribeTokenQuery_userByUnsubscribeToken_User_emailUnsubscribedRestaurants_Restaurant>
};

export type UserUnsubscribedRestaurantsByUnsubscribeTokenQuery_Query = {
  __typename?: 'Query',
  userByUnsubscribeToken: UserUnsubscribedRestaurantsByUnsubscribeTokenQuery_userByUnsubscribeToken_User
};


export type UserUnsubscribedRestaurantsByUnsubscribeTokenQueryVariables = Types.Exact<{
  unsubscribeToken: Types.Scalars['String']['input'];
}>;


export type UserUnsubscribedRestaurantsByUnsubscribeTokenQuery = UserUnsubscribedRestaurantsByUnsubscribeTokenQuery_Query;


export const UserUnsubscribedRestaurantsByUnsubscribeTokenQueryDocument = /*#__PURE__*/ document as unknown as DocumentNode<UserUnsubscribedRestaurantsByUnsubscribeTokenQuery, UserUnsubscribedRestaurantsByUnsubscribeTokenQueryVariables>;


/**
 * __useUserUnsubscribedRestaurantsByUnsubscribeTokenQuery__
 *
 * To run a query within a React component, call `useUserUnsubscribedRestaurantsByUnsubscribeTokenQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserUnsubscribedRestaurantsByUnsubscribeTokenQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserUnsubscribedRestaurantsByUnsubscribeTokenQuery({
 *   variables: {
 *      unsubscribeToken: // value for 'unsubscribeToken'
 *   },
 * });
 */
export function useUserUnsubscribedRestaurantsByUnsubscribeTokenQuery(baseOptions: ApolloReactHooks.QueryHookOptions<UserUnsubscribedRestaurantsByUnsubscribeTokenQuery, UserUnsubscribedRestaurantsByUnsubscribeTokenQueryVariables> & ({ variables: UserUnsubscribedRestaurantsByUnsubscribeTokenQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<UserUnsubscribedRestaurantsByUnsubscribeTokenQuery, UserUnsubscribedRestaurantsByUnsubscribeTokenQueryVariables>(UserUnsubscribedRestaurantsByUnsubscribeTokenQueryDocument, options);
      }
export function useUserUnsubscribedRestaurantsByUnsubscribeTokenQueryLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<UserUnsubscribedRestaurantsByUnsubscribeTokenQuery, UserUnsubscribedRestaurantsByUnsubscribeTokenQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<UserUnsubscribedRestaurantsByUnsubscribeTokenQuery, UserUnsubscribedRestaurantsByUnsubscribeTokenQueryVariables>(UserUnsubscribedRestaurantsByUnsubscribeTokenQueryDocument, options);
        }
// @ts-ignore
export function useUserUnsubscribedRestaurantsByUnsubscribeTokenQuerySuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<UserUnsubscribedRestaurantsByUnsubscribeTokenQuery, UserUnsubscribedRestaurantsByUnsubscribeTokenQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<UserUnsubscribedRestaurantsByUnsubscribeTokenQuery, UserUnsubscribedRestaurantsByUnsubscribeTokenQueryVariables>;
export function useUserUnsubscribedRestaurantsByUnsubscribeTokenQuerySuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<UserUnsubscribedRestaurantsByUnsubscribeTokenQuery, UserUnsubscribedRestaurantsByUnsubscribeTokenQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<UserUnsubscribedRestaurantsByUnsubscribeTokenQuery | undefined, UserUnsubscribedRestaurantsByUnsubscribeTokenQueryVariables>;
export function useUserUnsubscribedRestaurantsByUnsubscribeTokenQuerySuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<UserUnsubscribedRestaurantsByUnsubscribeTokenQuery, UserUnsubscribedRestaurantsByUnsubscribeTokenQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<UserUnsubscribedRestaurantsByUnsubscribeTokenQuery, UserUnsubscribedRestaurantsByUnsubscribeTokenQueryVariables>(UserUnsubscribedRestaurantsByUnsubscribeTokenQueryDocument, options);
        }
export type UserUnsubscribedRestaurantsByUnsubscribeTokenQueryHookResult = ReturnType<typeof useUserUnsubscribedRestaurantsByUnsubscribeTokenQuery>;
export type UserUnsubscribedRestaurantsByUnsubscribeTokenQueryLazyQueryHookResult = ReturnType<typeof useUserUnsubscribedRestaurantsByUnsubscribeTokenQueryLazyQuery>;
export type UserUnsubscribedRestaurantsByUnsubscribeTokenQuerySuspenseQueryHookResult = ReturnType<typeof useUserUnsubscribedRestaurantsByUnsubscribeTokenQuerySuspenseQuery>;
export type UserUnsubscribedRestaurantsByUnsubscribeTokenQueryQueryResult = ApolloReactCommon.QueryResult<UserUnsubscribedRestaurantsByUnsubscribeTokenQuery, UserUnsubscribedRestaurantsByUnsubscribeTokenQueryVariables>;